import * as React from 'react';
import { Recipe } from '@src/firebase/types';
import { ViewRecipeListItem } from '@src/routes/recipes/components/ViewRecipeListItem';

interface ViewRecipeListProps {
  className?: string;
  recipes: Recipe[];
}

/**
 * @name ViewRecipeList
 * @description tbd...
 */
const ViewRecipeList: React.FC<ViewRecipeListProps> = (props) => {
  const { className, recipes } = props;

  return (
    <div className={className}>
      <div className="bg-white">
        <div className="max-w-2xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
          <h2 className="sr-only">Recipes</h2>

          <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
            {recipes &&
              recipes.map((recipe) => (
                <ViewRecipeListItem recipe={recipe} key={recipe.id} />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export { ViewRecipeList };
export type { ViewRecipeListProps };
